import axios from 'axios';

const CSRF_TOKEN = document.querySelector("meta[name=csrf-token]").content;

const Very = {
    get(url) {
        return new Promise((resolve, reject) => {
            axios.get(url).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error.response)
            })
        })
    },
    post (url, params) {
        return new Promise((resolve, reject) => {
            axios.post(url, params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error.response)
            })
        })
    },
    patch(url, params) {
        return new Promise((resolve, reject) => {
            axios.patch(url, params).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error.response.data)
            })
        })
    },
    delete(url) {
        return new Promise((resolve, reject) => {
            axios.delete(url).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error.response)
            })
        })

    }
};

export default Very
